export default __webpack_public_path__ + "static/media/PEP.1e60cb24.png";